import { combineReducers } from "redux";
import { StateType } from "typesafe-actions";
import { reducer as alerts } from "src/apps/modules/alert/stores";
import { reducer as auths } from "src/apps/modules/auth/stores";

const rootReducers = combineReducers({ alerts, auths });
export type StoreTypes = StateType<typeof rootReducers>;
export default rootReducers;
